import { deleteAllData, insertValues } from "store/idb";
import { addMedsHistory, getCurrentUser, resetMedsHistoryState, resetMedsState, setMedsHistoryLoaded, setMedsHistoryLoading, setMedsLoaded, setMedsLoading } from "store/storeValtio";
//import { getConditions, getIngredients, getMeds, getMedsHistory, getSupplements, getUsersList } from 'store/storeValtio';
import { getNowISO } from "./generalHelpers";

const apiURL = 'https://api.itookitwhen.com/';

export async function syncData(target, json) {
    const currentUser = getCurrentUser();
    const registrationId = currentUser.registrationId;
    console.log('UserID: ', registrationId);

    var url = target + '/' + registrationId;
    console.log(target, ': ', url);
    var response = await postDataAPI(url, json);
    var newData = await response;
    return newData;
  }

  export async function loadDataFromFB(target, json) {
    const currentUser = getCurrentUser();
    const registrationId = currentUser.registrationId;
    console.log('UserID: ', registrationId);

    var url = target + '/' + registrationId;
    console.log(target, ': ', url);
    var response = await getDataAPI(url);
    var newData = await response;
    return newData;
  }

  // export async function syncDataAPI(url, json) {
  //   const jsonData = JSON.stringify(json);
  //   console.log('syncDataAPI', json);
  //   let response = await fetch(url, {
  //     method: 'POST', 
  //     mode: 'cors', 
  //     headers: {"Content-Type": "application/json"},
  //     body: jsonData
  //     })
  //   let data = await response.json();
  //   console.log("syncDataAPI result: ", data);
  //   return data;
  // }

  export async function postDataAPI(url, json) {
    const jsonString = (typeof json !== 'object') ? json : JSON.stringify(json) ;
    //console.log('postDataAPI', jsonString);
    const message = {
      method: 'POST', 
      mode: 'cors', 
      headers: {"Content-Type": "application/json"},
      body: jsonString
      };
      
    let response =  await fetch(apiURL + url, message);
    //console.log("postDataAPI response:", response);
    return response;
}

export async function getDataAPI(url) {
  console.log('getDataAPI', url);
  const response =  await fetch(apiURL + url, {
    method: 'GET', 
    mode: 'cors', 
    headers: {"Content-Type": "application/json"},
    });
    const data = await response.json();
    console.log('Fetch data:', data);
    return data;
}

// async function copyData() {
//     let data = getUsersList();
//     await sendData('users', data);
//     data = getMeds();
//     await sendData('medications', data);
//     data = getMedsHistory();
//     await sendData('history', data);
//     data = getConditions();
//     await sendData('conditions', data);
//     data = getSupplements();
//     await sendData('supplements', data);
//     data = getIngredients();
//     await sendData('ingredients', data);
//   }

//   async function sendData(dbName, json) {
//       //const url = 'https://localhost:7126/Sync/loadtable/' + dbName;
//       //postDataAPI(url, json);
//   }

export async function registerFirestore(json) {
    const url = 'register/';
    console.log('registerFirestore: ', url, json);
    let result = await postDataAPI(url, json)
    console.log('registerFirestore syncDataAPI result: ', result);
    return result;
  }
  
  
export async function getUserFromFirestore(userId) {
  let url = 'getRegistration/' + userId;
  const user = await getDataAPI(url);
  console.log('UserID: ', user[0].id);
  const userIdFB = user[0].id;
  return userIdFB;
}

export async function sendEmailText(emailTo, content)
{
  const message = {
    email: emailTo,
    message: content
  }
  
  const url = 'sendEmailText';
  let result = await postDataAPI(url, message)
  console.log('sendEmailText: ', result);
  return result;
}